export default "__VITE_ASSET__BOqru5e1__"